import CalculoProcedimentos from './services/CalculoProcedimentos'
import DadosCobranca from './services/DadosCobranca'
import Equipe from './services/Equipe'
import Especialidades from './services/Especialidades'
import Negociacoes from './services/Negociacoes'
import Procedimentos from './services/Procedimentos'
import Producao from './services/Producao'
import Provisao from './services/Provisao'
import Recebimento from './services/Recebimento'
import Relatorios from './services/Relatorios'
import Reports from './services/Reports'
import Tabelas from './services/Tabelas'
import Terms from './services/Terms'

export default {
  CalculoProcedimentos,
  DadosCobranca,
  Equipe,
  Especialidades,
  Negociacoes,
  Procedimentos,
  Producao,
  Provisao,
  Recebimento,
  Relatorios,
  Reports,
  Tabelas,
  Terms,
}
